export default {"src":"/_next/static/media/form-image.1b20f436.svg","height":370,"width":658};